import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import './Login.css';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [branding, setBranding] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();

  useEffect(() => {
    const customerId = searchParams.get('customerId');
    if (customerId) {
      fetchBranding(customerId);
    }
  }, [searchParams]);

  const fetchBranding = async (customerId) => {
    try {
      const response = await api.get(`/api/public-branding/${customerId}`);
      setBranding(response.data);
    } catch (error) {
      console.error('Error fetching branding:', error);
      // Don't show error to user, just fall back to default styling
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/api/login', {
        username,
        password
      });

      if (response.data.user) {
        authLogin(response.data.user);
        
        if (response.data.user.isRetail) {
          navigate('/products');
        } else {
          navigate('/inventory');
        }
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(error.response?.data?.message || 'An error occurred during login');
    }
  };

  // Get styles based on branding
  const getStyles = () => {
    if (!branding) return {};

    return {
      headerStyle: {
        background: branding.primaryColor || 'linear-gradient(195deg, #49a3f1 0%, #1A73E8 100%)'
      },
      buttonStyle: {
        background: branding.primaryColor || 'linear-gradient(195deg, #49a3f1 0%, #1A73E8 100%)'
      }
    };
  };

  const { headerStyle, buttonStyle } = getStyles();

  return (
    <div className="login-wrapper">
      <main className="login-content">
        <div 
          className="login-page-header" 
          style={{ 
            backgroundImage: "url('/splash.jpg')",
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="login-container">
            <div className="login-row">
              <div className="login-col">
                <div className="login-card login-fadeIn">
                  <div className="login-card-header">
                    <div className="login-gradient-primary" style={headerStyle}>
                      {branding?.logoUrl ? (
                        <img 
                          src={branding.logoUrl}
                          className="img-fluid px-3 mb-3"
                          alt="Company Logo"
                          style={{ maxHeight: '80px', objectFit: 'contain' }}
                        />
                      ) : (
                        <img 
                          src="/bannernew.png" 
                          className="img-fluid px-3"
                          alt="Default Logo"
                        />
                      )}
                      <h4 className="login-text-white login-text-center">
                        {branding?.displayName || 'Echo Portal'}
                      </h4>
                      <h4 className="login-text-white login-text-center">
                        Sign in
                      </h4>
                    </div>
                  </div>

                  <div className="login-card-body">
                    <form onSubmit={handleSubmit} className="login-text-center">
                      <div className="login-input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Username"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          required
                        />
                      </div>

                      <div className="login-input-group">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </div>

                      {error && (
                        <div className="login-text-center text-danger mb-3">
                          {error}
                        </div>
                      )}

                      <div className="login-text-center">
                        <button 
                          type="submit"
                          className="login-btn"
                          style={buttonStyle}
                        >
                          Sign in
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Login;
